export default {
  logo: require('./icon.png'),
  icon: require('./icon.png')
}
